import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M19.7473 5.39927H0V3.96573H19.7473V5.39927ZM19.7473 1.4707H0V2.04495H19.7473V1.4707ZM0.251906 7.30266V10.3239H20V7.30266H0.251906ZM0 18.529H19.7473V11.7665H0V18.529Z", fill: "#F2F2F2" }));
export {
  l as default
};
